import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPinShadow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 42.5,
	viewBox: "0 0 32 42",
	fill: "white",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("ellipse", {
		cx: 16,
		cy: 38,
		rx: 8,
		ry: 4,
		fill: "black",
		fillOpacity: .1,
		stroke: "none"
	})
});
export default SvgPinShadow;
